// Staus colours

import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";

export const OPTimeToAction = [
  ExecutionStrategyStatus.Executed,
  ExecutionStrategyStatus.ExecutedRPAgreeChange,
  ExecutionStrategyStatus.ExecutedRPChangeRequested, 
  ExecutionStrategyStatus.Filled,
  ExecutionStrategyStatus.NoMoreFills,
  ExecutionStrategyStatus.New,
  ExecutionStrategyStatus.Quoted,
  ExecutionStrategyStatus.Recalled,
  ExecutionStrategyStatus.Rejected,
];

export const RPTimeToAction = [
  ExecutionStrategyStatus.Acknowledged,
  ExecutionStrategyStatus.Awarded,
  ExecutionStrategyStatus.ExecutedOPChangeRequested,
  ExecutionStrategyStatus.New,
  ExecutionStrategyStatus.OffQuote,
  ExecutionStrategyStatus.QuoteExpired,
  ExecutionStrategyStatus.ReQuoteRequested,
  ExecutionStrategyStatus.ReSent,
  ExecutionStrategyStatus.Received,
  //ExecutionStrategyStatus.UpdateReqd
  ExecutionStrategyStatus.Working,
];

export const OPAffirmedAction = [

  ExecutionStrategyStatus.Affirmed,
];
export const RPAffirmedAction = [
  ExecutionStrategyStatus.Affirmed,
];

export const OPNoMoreActionsColour = [
  ExecutionStrategyStatus.NotDealt,
  ExecutionStrategyStatus.ReCreated,
  ExecutionStrategyStatus.Cancelled,
  ExecutionStrategyStatus.Expired, // LQC-2173 - lapsed, nothing left to action
];

// export const RPClosedAction = [
//   ExecutionStrategyStatus.Archived,
//   // ExecutionStrategyStatus.Closed,
//   ExecutionStrategyStatus.NotDealt,
// ];

export const timeToActionColour = "#EA8A48";
export const completeActionColour = "#06AA6D";
export const noMoreActionsColour = "gray";
// Muted (half-strength) variant of timeToActionColour — used on a CP cell that
// is "following" a pending trade-level default (no explicit per-CP override),
// to distinguish it from the full orange of a directly-overridden, pending CP.
export const mutedTimeToActionColour = "rgba(234, 138, 72, 0.5)"; // #EA8A48 @ 50%

// LQC-2173 - expiry urgency tints for the Expires cell background. Derived from
// timeToActionColour rather than a new yellow/orange ramp: orange already means
// "you need to act" in the status column of the same row, and an imminent
// expiry is exactly that. A second warning palette would put two colour
// languages side by side. rgba, not solid, so AG Grid's row hover, row
// selection and striping still read through.
export const expiryWarningBackground = "rgba(234, 138, 72, 0.15)"; // 15m or less
export const expiryUrgentBackground = "rgba(234, 138, 72, 0.35)"; // 5m or less

/**
 * Returns the status dot color for a given status and role.
 * Reuses the same arrays as StatusRenderer — single source of truth.
 */
export function getStatusColorByRole(status: string, role?: string): string {
  const s = status as ExecutionStrategyStatus;
  if (role === "OP") {
    if (OPTimeToAction.includes(s)) return timeToActionColour;
    if (OPAffirmedAction.includes(s)) return completeActionColour;
    if (OPNoMoreActionsColour.includes(s)) return noMoreActionsColour;
  } else if (role === "RP") {
    if (RPTimeToAction.includes(s)) return timeToActionColour;
    if (RPAffirmedAction.includes(s)) return completeActionColour;
  }
  return "gray";
}

export const StatusRenderer = (data: any) => {
  if (data.role == "OP") {
    const status = data.status;

    if (OPTimeToAction.includes(status)) {
      return {
        color: timeToActionColour,
        fontWeight: "550",
      };
    } else if (OPAffirmedAction.includes(status)) {
      return {
        color: completeActionColour,
        fontWeight: "550",
      };
    } else if (OPNoMoreActionsColour.includes(status)) {
      return {
        color: noMoreActionsColour,
        fontWeight: "normal",
      };
    }
  } else if (data.role == "RP") {
    const status = data.status;

    if (RPTimeToAction.includes(status)) {
      return {
        color: timeToActionColour,
        fontWeight: "550",
      };
    } else if (RPAffirmedAction.includes(status)) {
      return {
        color: completeActionColour,
        fontWeight: "550",
      };
    }
  }
};
